/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService
 */

export const AgentConfigChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.AgentConfigChirpContentBlock';
export const ContextChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ContextChirpContentBlock';
export const DisplayOnlyChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.DisplayOnlyChirpContentBlock';
export const FileChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.FileChirpContentBlock';
export const ImageChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ImageChirpContentBlock';
export const ImageToolResultChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ImageToolResultChirpContentBlock';
export const PdfChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.PdfChirpContentBlock';
export const PendingToolResultChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.PendingToolResultChirpContentBlock';
export const RedactedThinkingChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.RedactedThinkingChirpContentBlock';
export const ServerToolUseChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ServerToolUseChirpContentBlock';
export const TextChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.TextChirpContentBlock';
export const ThinkingChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ThinkingChirpContentBlock';
export const ToolApprovalRequestChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ToolApprovalRequestChirpContentBlock';
export const ToolResultChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ToolResultChirpContentBlock';
export const ToolUseChirpContentBlockTypename = 'com.hubspot.aviator.agent.message.content.chirp.ToolUseChirpContentBlock';
export const BooleanFieldValueTypename = 'com.hubspot.chirp.ext.models.BooleanFieldValue';

/**
 *  This class can be used as a response type in cases where no response is needed or
 *  where <code>void</code> might have been used in a REST-ful context.
 */

export const DoubleFieldValueTypename = 'com.hubspot.chirp.ext.models.DoubleFieldValue';
export const FloatFieldValueTypename = 'com.hubspot.chirp.ext.models.FloatFieldValue';
export const IntFieldValueTypename = 'com.hubspot.chirp.ext.models.IntFieldValue';
export const ListFieldValueTypename = 'com.hubspot.chirp.ext.models.ListFieldValue';
export const LongFieldValueTypename = 'com.hubspot.chirp.ext.models.LongFieldValue';
export const MapFieldValueTypename = 'com.hubspot.chirp.ext.models.MapFieldValue';
export const NullFieldValueTypename = 'com.hubspot.chirp.ext.models.NullFieldValue';
export const StringFieldValueTypename = 'com.hubspot.chirp.ext.models.StringFieldValue';
export const listConversationsRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'listConversations',
  auth: 'app',
  fingerprint: 'gFD946Aed0btvVWwEGRZ1lJ8GnIfkswz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getConversationRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'getConversation',
  auth: 'app',
  fingerprint: 'DuyxfCHhtPncd83FBMorf1J8GnIfkswz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getConversationsByIdsRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'getConversationsByIds',
  auth: 'app',
  fingerprint: 'IOkS6z72Xa7Y2f5hgJKKg1J8GnIfkswz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const deleteConversationRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'deleteConversation',
  auth: 'app',
  fingerprint: 'Ad5bOGVxNpOOUe2e_r4XmVJ8GnIfkswz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const renameConversationRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'renameConversation',
  auth: 'app',
  fingerprint: 'FSQshBcIox2OUe2e_r4XmVJ8GnIfkswz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const shareConversationRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'shareConversation',
  auth: 'app',
  fingerprint: 'tqqOq1B6yKaOUe2e_r4XmVJ8GnIfkswz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const revokeConversationShareRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'revokeConversationShare',
  auth: 'app',
  fingerprint: 'rgIvUH6ErouOUe2e_r4XmVJ8GnIfkswz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getConversationSharesRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'getConversationShares',
  auth: 'app',
  fingerprint: 'zUK_Vrm37gcGP8oVd-sYm1J8GnIfkswz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createConversationRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'createConversation',
  auth: 'app',
  fingerprint: 'kjnAZ5umOq0uF8VgGwCxllJ8GnIfkswz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getMessageRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'getMessage',
  auth: 'app',
  fingerprint: 'bgopicGDDcxURENenm9b3lJ8GnIfkswz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getMessagePayloadRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'getMessagePayload',
  auth: 'app',
  fingerprint: 'rTbNkRv40g80_533PNZUXVJ8GnIfkswz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateCollectionIdRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'updateCollectionId',
  auth: 'app',
  fingerprint: 'zNJbsKdDoxWOUe2e_r4XmVJ8GnIfkswz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const appendTranscriptRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'appendTranscript',
  auth: 'app',
  fingerprint: '3IcNCS4Xg-MWtxKQNuzIDVJ8GnIfkswz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const forkConversationRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'forkConversation',
  auth: 'app',
  fingerprint: 'FqbnXljTlnk5ODgiDwNsPFJ8GnIfkswz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const searchConversationsRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'searchConversations',
  auth: 'app',
  fingerprint: '0sYSQfzRdCX6LIw_2Tf67lJ8GnIfkswz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const markConversationReadRpc = {
  serviceName: 'com.hubspot.breeze.engine.rpc.BreezeEngineConversationsService',
  rpcName: 'markConversationRead',
  auth: 'app',
  fingerprint: '__y8xApXWTuOUe2e_r4XmVJ8GnIfkswz',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};